import React from 'react';
import styled from 'styled-components';

import { colors } from '@/constants/theme';

type Props = {
  className?: string;
  description: string;
};

const Description = ({ className, description }: Props) => {
  return (
    <Component className={className}>
      <Text>{description}</Text>
    </Component>
  );
};

export default Description;

const Component = styled.div`
  padding: 1rem 1rem 1.1875rem;
  border: 2px solid ${colors.primary};
`;
const Text = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;

  color: ${colors.primary};
`;
